import React from 'react';

import { SimpleDonutChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
  gradingType?: 'percentage' | 'value';
  sections?: any;
  size?: 'sm' | 'lg';
}

const PerformanceChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <>
      <div className="hidden-xs">
        <SimpleDonutChart
          chartProps={{ animate: false }}
          colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
          data={{ value: 60 }}
          interior={<></>}
          size={props.size === 'sm' ? 80 : 150}
        />
      </div>

      <div className="visible-xs">
        <SimpleDonutChart
          chartProps={{ animate: false }}
          colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
          data={{ value: 60 }}
          interior={<></>}
          size={150}
        />
      </div>
    </>
  );

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    const filters = props.sections ? (
      { ...props.filters, sections: props.sections.map((section) => section.slug) }
    ) : props.filters

    return (
      <StatisticData
        filters={filters}
        name="performance"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <Chart gradingType={props.gradingType} size={props.size} />
      </StatisticData>
    );
  }
};

const Chart = ({ data, gradingType, size }) => {
  const dataForGradingType = gradingType ? (
    data.filter((datum) => datum.label?.toLowerCase() === gradingType)
  ) : data;
  // When there is data returned to indicatate no activity, it may not have the grading type
  // specified, so fallback to the original, unfilterd data
  const datum = dataForGradingType[0] || data[0];

  return (
    <>
      <div className="hidden-xs">
        <SimpleDonutChart
          chartProps={{ animate: false }}
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
          data={datum}
          size={size === 'sm' ? 80 : 150}
        />
      </div>

      <div className="visible-xs">
        <SimpleDonutChart
          chartProps={{ animate: false }}
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
          data={datum}
          size={150}
        />
      </div>
    </>
  );
};

export default PerformanceChart;
